import Navbar from './components/Navbar';
import Hero from './components/Hero';
import HotWorks from './components/HotWorks';
import Categories from './components/Categories';
import NewReleases from './components/NewReleases';
import Guide from './components/Guide';
import Faq from './components/Faq';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 font-body text-foreground-900">
      <Navbar />
      <main>
        <Hero />
        <HotWorks />
        <Categories />
        <NewReleases />
        <Guide />
        <Faq />
        <About />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}